export default {
  sections: {
    order_summary: 'Order summary',
  },
  labels: {
    add_items: 'Add items to get started',
    item_count_one: '{{count}} item',
    item_count_other: '{{count}} items',
  },
  buttons: {
    return: 'Return',
  },
  tip: 'Tip',
};
